module.exports = __webpack_public_path__ + "img/postgres.1537b82e.png";